import GeneralServices from "./GeneralServices";
import {
  GetPaymentLinkDto,
  GetPaymentLinkResponseDto,
  GetPaymentStatusDto,
  GetPaymentStatusResponseDto,
  PostSendingErrorMailDto,
  StatusResponseItem,
} from "./dto/request/PaymentRequests.dto";

class PaymentServices {
  getPaymentLink = async (args: GetPaymentLinkDto): Promise<string> => {
    const body = {
      amount: args.cantidad,
      currency: "EUR",
      order: `${args.pedido}`,
      language: "1",
    };

    try {
      const response = await GeneralServices.post({
        setLoading: args.setLoading,
        loader: args.loader,
        endpoint: `redsys/onlinePayment`,
        data: body,
      });

      const data: GetPaymentLinkResponseDto = response.data;

      return data.response.payUrl;
    } catch (err) {
      throw err;
    }
  };

  getPaymentStatus = async (args: GetPaymentStatusDto): Promise<StatusResponseItem[]> => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: args.loader,
        endpoint: `redsys/getPaymentStatus?order=${args.pedido}`,
      });
      const data: GetPaymentStatusResponseDto = response.data;
      return data.response;
    } catch (err) {
      throw err;
    }
  };

  SendPaymentErrorMail = async (args: PostSendingErrorMailDto) : Promise<any> => {
    try {
      const response = await GeneralServices.post({
        setLoading: args.setLoading,
        loader: args.loader,
        endpoint: `redsys/sendErrorMail`,
        data:args.data
      });
      return response;
    } catch (err) {
      throw err;
    }
  };
}

export default new PaymentServices();
